import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, BooleanDecoder, DateDecoder, field, IntegerDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from "uuid";
import { Group } from '../Group';
import { StockReservation } from '../StockReservation';
import { GroupPrice } from '../GroupSettings';
import { RegisterItemOption } from './checkout/RegisterItem';
export class Registration extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.options = [];
        this.memberId = '';
        /**
         * @deprecated
         */
        this.cycle = 0;
        /// Set registeredAt to null if the member is on the waiting list for now
        this.registeredAt = null;
        /// Keep spot for this member temporarily
        this.reservedUntil = null;
        /**
         * Currently not yet used
         */
        this.deactivatedAt = null;
        this.createdAt = new Date();
        this.updatedAt = new Date();
        /**
         * @deprecated - replaced by group type
         */
        this.waitingList = false;
        this.canRegister = false;
        this.price = 0;
        this.pricePaid = 0;
        this.stockReservations = [];
    }
    get groupId() {
        return this.group.id;
    }
    get description() {
        const descriptions = [];
        if (this.group.settings.getFilteredPrices().length > 1) {
            descriptions.push(this.groupPrice.name);
        }
        for (const option of this.options) {
            descriptions.push(option.optionMenu.name + ': ' + option.option.name + (option.option.allowAmount ? ` x ${option.amount}` : ""));
        }
        return descriptions.filter(d => !!d).join("\n");
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], Registration.prototype, "id", void 0);
__decorate([
    field({ decoder: Group, version: 266 })
], Registration.prototype, "group", void 0);
__decorate([
    field({ decoder: GroupPrice, version: 305 })
], Registration.prototype, "groupPrice", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(RegisterItemOption), version: 305 })
], Registration.prototype, "options", void 0);
__decorate([
    field({ decoder: StringDecoder, version: 250 })
], Registration.prototype, "organizationId", void 0);
__decorate([
    field({ decoder: StringDecoder, version: 300 })
], Registration.prototype, "memberId", void 0);
__decorate([
    field({ decoder: IntegerDecoder, optional: true })
], Registration.prototype, "cycle", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], Registration.prototype, "registeredAt", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], Registration.prototype, "reservedUntil", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], Registration.prototype, "deactivatedAt", void 0);
__decorate([
    field({ decoder: DateDecoder })
], Registration.prototype, "createdAt", void 0);
__decorate([
    field({ decoder: DateDecoder })
], Registration.prototype, "updatedAt", void 0);
__decorate([
    field({ decoder: BooleanDecoder, version: 16, optional: true })
], Registration.prototype, "waitingList", void 0);
__decorate([
    field({ decoder: BooleanDecoder, version: 20 })
], Registration.prototype, "canRegister", void 0);
__decorate([
    field({ decoder: IntegerDecoder, optional: true })
], Registration.prototype, "price", void 0);
__decorate([
    field({ decoder: IntegerDecoder, optional: true })
], Registration.prototype, "pricePaid", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StockReservation), nullable: true, version: 299 })
], Registration.prototype, "stockReservations", void 0);
//# sourceMappingURL=Registration.js.map